import '../css/style.css'

export default function Content() {
    return(
        <div className='content'>
            <div className='about-us-container'>
                <div className='about-us-content'>
                    <p>DWB-Poland Sp. z o.o. od około 25 lat konsekwentnie rozwija się w zakresie sprężonego powietrza z ukierunkowaniem na dostęp części zamiennych, chłodnic oraz serwisu  turbo kompresoru typu CENTAC® firmy Ingersoll Rand.</p>
                    <p>Wśród znanych koncernów oraz mniejszych zakładów produkcyjnych na rynku europejskim i polskim DWB-Poland cieszy się wypracowanym zaufaniem i pozytywną opinią nie tylko wśród użytkowników kompresorów Centac lecz również Cameron, Cooper, Joy, Atlas Capco itp . Jako jedni z niewielu oferujemy i wykonujemy regenerację w pełnym zakresie układów przepływowych maszyn.</p>
                    <p>Nasi pracownicy to solidni fachowcy wykonujący swoją pracę z fascynacją i zaangażowaniem.</p>
                </div>
            </div>
            <div className='about-us-image'></div>
            <div className='about-us' id="isocert">Certyfikat systemu zarządzania:</div>
            <div className='certi'>
                <img alt="IsoCert" src="https://dwb.com.pl/wp-content/uploads/2023/02/isocert_pl.png"/>
                <img alt="IsoCertAng" src="https://dwb.com.pl/wp-content/uploads/2023/02/isocert_eng.png"/>
            </div>
        </div>
    )
}